module.exports = __webpack_public_path__ + "static/chess-a2d8621ad301306a1ed7e0c3e0703479.png";